import Crud from '../views/ClienteApi/Crud'
import Entity from '../views/ClienteApi/Add'

let routes = {
    path: '/clientes_api',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/clientes_api/add',
            name: 'NewClienteApi',
            component: Entity
        },
        {
            path: '/clientes_api/edit/:id?',
            name: 'EditClienteApi',
            component: Entity
        },
        {
            path: '/clientes_api',
            name: 'list-clientes_api',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Clientes de API',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
